/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from "@/axios.js"

export default {
    fetchDataListItems({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get("admin/1/list")
          .then((response) => {
            commit('SET_THEMES', response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    setCurrentTheme({ commit }, theme) {
      commit('SET_CURRENT_THEME', theme)
    }
}
